"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorContext = void 0;
const react_1 = require("react");
exports.SelectorContext = (0, react_1.createContext)({});
//# sourceMappingURL=selector-context.js.map